import CreateCampaignDataForm from "./_components/forms/CreateCampaignDataForm";
import { Link } from "react-router-dom";
import { Button } from "@/components/_components/button";
import { ArrowLeft } from "lucide-react";
import { PageAccessGuard } from "@/components/auth/PageAccessGuard";

const CreateCampaignPage: React.FC = () => {
  return (
    <PageAccessGuard authority="ADMIN_CAMPAIGN_MGMT_UPDATE">
      <CreateCampaignContent />
    </PageAccessGuard>
  );
};

const CreateCampaignContent: React.FC = () => {
  return (
    <div className="bg-background">
      <div className="sticky top-0 z-10 bg-card/95 backdrop-blur-sm border-b border-border shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center space-x-4">
              <Link to="/campaign-management">
                <Button variant="ghost" className="text-base text-muted-foreground hover:bg-accent transition-colors">
                  <ArrowLeft className="h-5 w-5 mr-2" />
                  Back to Campaigns
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-2 sm:px-2 lg:px-4 py-4">
        <CreateCampaignDataForm />
      </div>
    </div>
  );
};

export default CreateCampaignPage;